export const LoadingData = () => {
  return (
    <div className="flex flex-col items-center justify-center h-96 w-full mt-2 p-2 mb-10">
      <div className="w-8 h-8 border-4 border-[#0075E3] border-t-transparent rounded-full animate-spin mb-4"></div>
      <div className="text-[#667085] font-inter text-sm">
        Generating Heatmap...
      </div>
    </div>
  );
};
